import { createFileRoute, Link } from '@tanstack/react-router';
import { Button, Col, Divider, Flex, Row, Space, Typography } from 'antd';

import { useGetApplications } from '@/api/useGetApplications';
import { getImageUrl } from '@/shared/utils';

export const Route = createFileRoute('/apps/')({
  component: AppsPage,
});

export function AppsPage() {
  const { data } = useGetApplications();

  return (
    <Col>
      <Typography.Title level={2}>Software</Typography.Title>
      <Typography.Text>Hier finden Sie eine Übersicht aller verfügbaren Software.</Typography.Text>
      <Divider />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 }}>
        {data?.map((item) => (
          <Col xs={24} md={24} lg={12} xl={12} xxl={6} style={{ padding: 8 }} key={item.name}>
            <Flex align={'center'} gap={16}>
              <img src={getImageUrl(item.logo)} style={{ width: 75 }} alt={item.displayName} />
              <Space
                direction={'vertical'}
                style={{ justifyContent: 'start', width: '100%' }}
                size={0}
              >
                <Typography.Text strong>{item.displayName}</Typography.Text>
                <Typography.Paragraph type={'secondary'} ellipsis={{ rows: 2 }}>
                  {item.shortDescription}
                </Typography.Paragraph>
              </Space>
              {item.type === 'desktop-app' ? (
                <Button type={'default'} variant={'filled'} shape={'round'}>
                  <Link
                    to='/apps/$name'
                    params={{ name: item.name }}
                    style={{ alignSelf: 'center' }}
                  >
                    Anzeigen
                  </Link>
                </Button>
              ) : (
                <Button
                  type={'default'}
                  variant={'filled'}
                  shape={'round'}
                  onClick={() => item.properties?.url && window.open(item.properties.url, '_blank')}
                >
                  Anzeigen
                </Button>
              )}
            </Flex>
          </Col>
        ))}
      </Row>
    </Col>
  );
}
